module.exports = __webpack_public_path__ + "static/media/iconfinder_medical-healthcare-hospital-13_4082108.0d71bd67.svg";